export const LOCALES = {
    en_US: 'en_US', // united states
    en_es: 'en-es', // spanish in us
    en_CA: 'en_CA', // canada
    fr_ca: 'fr-ca', // french
    es_ar: 'es-ar', // argentina
    es_mx: 'es-mx', // mexico
    en_eu: 'en-eu', // europe
    en_GB: 'en_GB', // uk
    jp: 'jp',       // japan
    es_pe: 'es-pe', // peru
    es_co: 'es-co', // colombia
    es_cl: 'es-cl', // chile
    pt_br: 'pt-br', // brasil
    en_IE: 'en_IE'  // ireland
};
